import { createRoot } from 'react-dom/client'
import '@mui/material/Alert'
import './index.css'
import App from './App.tsx'

declare module '@mui/material/IconButton' {
  interface IconButtonOwnProps {
    variant?: 'background'
  }
}

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
      translucent: true; // Add 'custom' as a valid variant
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsSizeOverrides {
      extraSmall: true;
  }
}

declare module "@mui/material/Alert" {
  interface AlertPropsColorOverrides {
    theme: true;
  }
}

createRoot(document.getElementById('root')!).render(
    <App />
)
